'use client'

import type { MantineColorScheme, MantineColorSchemeManager } from '@mantine/core'

import { persistColorScheme } from '@/lib/api/user-preferences/user-preferences.client'
import { DEFAULT_COLOR_SCHEME } from '@/lib/theme/constants'

/**
 * Drop-in replacement for Mantine's `RedisColorSchemeManager` that
 * stores the scheme through the user preferences API. Mantine requires `get`
 * to be synchronous, so the value read on the server is passed in as
 * `initialColorScheme` and kept in memory from there on.
 */
export const createColorSchemeManager = (
  initialColorScheme: MantineColorScheme,
): MantineColorSchemeManager => {
  let colorScheme = initialColorScheme

  return {
    get: () => colorScheme,
    set: (value) => {
      colorScheme = value
      persistColorScheme(value)
    },
    subscribe: () => {},
    unsubscribe: () => {},
    clear: () => {
      colorScheme = DEFAULT_COLOR_SCHEME
      persistColorScheme(DEFAULT_COLOR_SCHEME)
    },
  }
}
